import { render, staticRenderFns } from "./PagamentoHistoricoDetalhe.vue?vue&type=template&id=4ece1c23&"
import script from "./PagamentoHistoricoDetalhe.vue?vue&type=script&lang=js&"
export * from "./PagamentoHistoricoDetalhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports